export const state = () => ({});

export const mutations = {};

export const getters = {};

export const actions = {
  login() {},
  registeruser() {},
  logout() {},
};
